import { render, staticRenderFns } from "./DetailBarrier.vue?vue&type=template&id=58f075cf&scoped=true"
import script from "./DetailBarrier.vue?vue&type=script&lang=js"
export * from "./DetailBarrier.vue?vue&type=script&lang=js"
import style0 from "./DetailBarrier.vue?vue&type=style&index=0&id=58f075cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f075cf",
  null
  
)

export default component.exports